import { useMemo, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { useHydrated } from "@tanstack/react-router";
import { useSession } from "@/lib/auth-client";
import { getClientFeatureFlags } from "./featureFlags.functions";
import { CLIENT_FEATURE_FLAG_DEFAULTS } from "./types";
import { FeatureFlagsContext } from "./FeatureFlagsContext";

export function FeatureFlagsProvider({ children }: { children: ReactNode }) {
  const hydrated = useHydrated();
  const { data: session, isPending: sessionPending } = useSession();
  const userId = session?.user.id ?? null;
  const email = session?.user.email ?? null;
  const query = useQuery({
    queryKey: ["client-feature-flags", userId, email],
    queryFn: () => getClientFeatureFlags(),
    enabled: hydrated && !sessionPending,
    staleTime: Infinity,
  });

  const value = useMemo(
    () => ({
      flags: query.data ?? CLIENT_FEATURE_FLAG_DEFAULTS,
      isPending: query.isPending,
      isError: query.isError,
    }),
    [query.data, query.isPending, query.isError],
  );

  return <FeatureFlagsContext value={value}>{children}</FeatureFlagsContext>;
}
